import React from 'react';
import { useSelector } from 'react-redux';
import {
  selectChangeRequestFilterVisible,
  selectTileView,
} from './store/selectors';
import ChangeRequestSearch from './change-request-search';
import ChangeRequestFilter from './change-request-filter';
import ChangeRequestTile from './change-request-tile';
import ChangeRequestTable from './change-request-table';

const ChangeRequestContent = () => {
  const isFilterVisible = useSelector(selectChangeRequestFilterVisible);
  const showTileView = useSelector(selectTileView);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <ChangeRequestSearch />
        </div>
        {isFilterVisible && <ChangeRequestFilter />}
        {showTileView ? <ChangeRequestTile /> : <ChangeRequestTable />}
      </div>
    </div>
  );
};

export default ChangeRequestContent;
